import { Injectable } from '@angular/core';
import { WebApisService } from './web-apis.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SocketService } from 'app/services/socket.service';
import { AuthenticationService } from '../auth/service/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private userID: string = '';
  private _unsubscribeAll: Subject<any>;
  constructor(private webApi: WebApisService, private socket: SocketService, private _authService: AuthenticationService) {
    this._unsubscribeAll = new Subject();
    this._authService.currentUser.pipe(takeUntil(this._unsubscribeAll)).subscribe((user:any) =>{
      if(new Object(user).hasOwnProperty('user')){
        this.userID = user.user.id;
      }
    });
  }

  generateOTP(email){
    return this.webApi.post(`/auth/otp/generate`, { email: email});
  }

  createUser(data){
    return this.webApi.post(`/auth/member/register`, data);
  }

  refreshUserToken(){
    let token = this._authService.currentUserValue.refreshToken;
    console.log(token);
    return this.webApi.post(`/auth/member/refreshToken`, { refreshToken: token})
  }

  createUpdateCard(info){
    return this.webApi.post(`/payment/user/${this.userID}/card/createOrUpdate`, info);
  }

  createSubscription(product, code){
    let data = {product: product};
    if(code != ''){
      data['code'] = code;
    }
    return this.webApi.post(`/payment/user/${this.userID}/subscription/create`, data);
  }

  updateSubscription(product, code){
    let data = {product: product};
    if(code != ''){
      data['code'] = code;
    }
    return this.webApi.put(`/payment/user/${this.userID}/subscription/update`, data);
  }

  cancelSubscription(reason){
    return this.webApi.put(`/payment/user/${this.userID}/subscription/cancel`, {reason: reason});
  }

  getUserInvoices(){
    return this.webApi.get(`/payment/user/${this.userID}/invoice`);
  }

  updateUser(info){
    return this.webApi.put<any>(`/user/${this.userID}`, info);
  }

  changeUserPassword(data){
    return this.webApi.post<any>(`/user/change-password`, data);
  }

  addUserNews(news){
    return this.webApi.post(`/news/user/${this.userID}`, news);
  }

  getUserNews(){
    return this.webApi.get(`/news/user/${this.userID}`);
  }

  deleteUserNews(news_id){
    return this.webApi.delete(`/news/${news_id}/user/${this.userID}`,{});
  }

  checkPaymentDiscount(code: string){
    return this.webApi.get<any>(`/payment/discount/${code}`);
  }

  walletAuth(){
    return this.webApi.get<any>(`/auth/wallet/authenticate`).toPromise();
  }

  walletLogin(data){
    return this.webApi.post<any>(`/auth/wallet/login`, data);
  }
}
